export default "https://cdn-static.gokick.com/assets/f7932cbd9535e06fbf9353fcd5d5fd5cf044a6ff/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";